// extracted by mini-css-extract-plugin
export default {"logoPurple":"LogoPurple-module__logoPurple__wAaZ6","logoGlobe":"LogoPurple-module__logoGlobe__HdhXH"};